import { platformBrowser } from '@angular/platform-browser';
import { defineCustomElements } from '@cix-software-labs/stl-ui-components/loader';
import { AppModule } from './app/app.module';

// Load configuration BEFORE Angular bootstraps
// This ensures config is available when MSAL factories are executed
platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.error(err));
  
// Initialize Stencil UI Components
defineCustomElements(globalThis as unknown as Window);
